import { useEffect, useState, useContext } from "react";
import { GlobalContext } from "store/globalContext";
import { useAppDispatch } from "store/hooks";
import { showError, hideError } from "store/reducers/errorReducer";
import { useCreateApiCall } from "hooks/useCreateApiCall";
import { API } from "aws-amplify";

export const useSpecialists = () => {
  const dispatch = useAppDispatch();
  const { createApiCall } = useCreateApiCall();
  const { userData } = useContext(GlobalContext);

  const [isLoading, setIsLoading] = useState(true);
  const [specialists, setSpecialists] = useState([]);

  const specialistInfoReducer = (
    acc,
    { id, firstName, lastName, role, email, phone, organizationId }
  ) => ({
    ...acc,
    [id]: {
      label: [`${firstName} ${lastName}`, role, email, phone]
        .filter(Boolean)
        .join(", "),
      selected: false,
      organizationId,
    },
  });

  const specialistsSorter = (a, b) =>
    `${a.firstName}${a.lastName}` > `${b.firstName}${b.lastName}` ? 1 : -1;

  const getSpecialistById = (id) => specialists.find((item) => item.id === id);

  const loadData = createApiCall(async () => {
    setIsLoading(true);
    dispatch(hideError());
    try {
      const specialistList = userData?.organizationId
        ? await API.get(
            "restApi",
            // @ts-ignore
            `/specialists_by_org_id/${userData?.organizationId}`,
            {}
          )
        : await API.get(
            "restApi",
            // @ts-ignore
            `/specialists_by_org_id/referral-stream`,
            {}
          );
      const sortedSpecialistList = (specialistList?.Items ?? []).sort(
        specialistsSorter
      );

      setSpecialists(sortedSpecialistList);
    } catch (e) {
      // @ts-ignore
      dispatch(showError(e?.message ?? "Something went wrong"));
    } finally {
      // dispatch(hideSpinner());
      setIsLoading(false);
    }
  });

  const specialistsOptions = specialists.reduce(
    (acc, { id, firstName, lastName, role, email, phone, organizationId }) => ({
      ...acc,
      [id]: {
        label: [`${firstName} ${lastName}`, role, email, phone]
          .filter(Boolean)
          .join(", "),
        organizationId,
        role,
      },
    }),
    {}
  );

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    specialists,
    getSpecialistById,
    specialistInfoReducer,
    isLoading,
    loadData,
    specialistsOptions,
  };
};
